module.exports = __webpack_public_path__ + "img/Icons for SPIM Sidebar-56.aa761f69.svg";